import { IMessage } from "domain/IMessage";
import API from "utils/API";
import authHeader from "utils/auth-header";
import { IGetReportsResponse } from "../domain/IGetReportsResponse";
import { IReport } from "../domain/IReport";
import { IGetScrollDataRequestParams } from "Dashboard/scenes/Chat/domain/IGetScrollDataRequestParams";
import { getQeuryParams } from "utils/queryParamsUtil";

const getAllReports = async (
  params: IGetScrollDataRequestParams,
  signal: AbortSignal
): Promise<IReport[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetReportsResponse>(
      `/reports/protected/report${getQeuryParams(params)}`,
      { headers, signal }
    );
    let reports = response.data.reports;
    return reports;
  } catch (err) {
    throw err;
  }
};

const deleteReport = async (reportId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/reports/protected/report/${reportId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

export const reportsService = {
  getAllReports,
  deleteReport
};
